var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiloSkipArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61211 7.63876L0.930933 1.95758C0.578849 1.6055 0.578849 1.03314 0.930933 0.681055C1.28302 0.328971 1.85538 0.328971 2.20746 0.681055L8.5269 7.0005C8.87989 7.35258 8.87989 7.92494 8.5269 8.27703L2.20746 14.5965C1.85538 14.9486 1.28302 14.9486 0.930933 14.5965C0.578849 14.2444 0.578849 13.672 0.930933 13.3199L6.61211 7.63876ZM14.0209 7.63876L8.33968 1.95758C7.98759 1.6055 7.98759 1.03314 8.33968 0.681055C8.69176 0.328971 9.26412 0.328971 9.6162 0.681055L15.9356 7.0005C16.2886 7.35258 16.2886 7.92494 15.9356 8.27703L9.6162 14.5965C9.26412 14.9486 8.69176 14.9486 8.33968 14.5965C7.98759 14.2444 7.98759 13.672 8.33968 13.3199L14.0209 7.63876Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiloSkipArrow);
export default __webpack_public_path__ + "static/media/hilo-skip-arrow.0412d433773e5d5eee43beb841b332d4.svg";
export { ForwardRef as ReactComponent };